/**
 * Page-level colours with no rawColors leaf, as [light, dark]. installColorVars emits them as
 * CSS variables so these surfaces follow the light/dark mode like every rawColors token.
 */
export const pageColorVars = {
  /** Content panel behind non-home pages (ResponsiveBox). */
  "--mb-page-surface": ["#F8FAFF", "#171126"],
} as const;

export const pageVar = (name: keyof typeof pageColorVars) =>
  `var(${name}, ${pageColorVars[name][0]})`;
